/**
 * NOTE: Static policies are currently stored in code as a temporary solution.
 * These policies will be moved to a separate storage location to maintain
 * synchronization with the frontend implementation and allow for easier policy management.
 * TODO: Move static policies to a centralized storage solution
 */

import { StaticPolicySet } from "@cedar-policy/cedar-wasm/nodejs";
import { StaticPolicyStore } from "./StaticPolicyStore";

const STATIC_POLICIES: StaticPolicySet = {
    "property-owner-policy": `permit (
        principal in ROLE::"ORGANIZATION_OWNER",
        action in [Action::"CREATE"],
        resource is PROPERTY
    );`,
    "property-admin-policy": `permit (
        principal,
        action in Action::"ADMIN_ACTION_GROUP",
        resource
    )
    when { 
        resource has createdBy && 
        principal == resource.createdBy
    } unless { 
        action == Action::"CREATE"
    };`
};

export class DefaultStaticPolicyStore implements StaticPolicyStore {
    public async getStaticPolicies(): Promise<StaticPolicySet> {
        return STATIC_POLICIES;
    }
}

export const defaultStaticPolicyStore = new DefaultStaticPolicyStore();